import { createPortal } from "react-dom";

const ResetPasswordModal = ({ open, onClose, user, onConfirm, isLoading }) => {
  if (!open) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
      onClick={(e) => e.target === e.currentTarget && !isLoading && onClose()}
    >
      <div className="absolute inset-0 bg-black/50" />

      <div className="relative w-full max-w-sm bg-white rounded-3xl shadow-2xl overflow-hidden">
        <div className="bg-black px-6 py-5 flex items-center justify-between">
          <h2 className="text-white text-base font-bold">Reset Password</h2>
          <button
            onClick={onClose}
            disabled={isLoading}
            className="text-gray-400 hover:text-white transition-colors disabled:opacity-60"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="px-6 py-5">
          <div className="flex items-center gap-3 p-4 bg-amber-50 rounded-xl border border-amber-100">
            <div className="w-9 h-9 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0">
              <svg className="w-5 h-5 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <p className="text-sm text-gray-700">
              Reset password for{" "}
              <span className="font-semibold text-gray-900">
                {user?.firstName} {user?.lastName}
              </span>
              ?
              <span className="block text-xs text-gray-400 mt-0.5">
                Password will be set to the default and user must change it on next login.
              </span>
            </p>
          </div>
        </div>

        <div className="px-6 py-4 border-t border-gray-100">
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className="w-full bg-amber-600 hover:bg-amber-700 text-white py-3 rounded-xl font-semibold text-sm active:scale-[0.98] transition-all duration-200 disabled:opacity-70"
          >
            {isLoading ? "Resetting..." : "Reset Password"}
          </button>
          <button
            onClick={onClose}
            disabled={isLoading}
            className="w-full mt-2.5 py-2.5 rounded-xl text-sm text-gray-500 hover:text-black font-medium border border-gray-200 hover:border-gray-400 transition-all duration-200 disabled:opacity-70"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ResetPasswordModal;

